module.exports = __webpack_public_path__ + "img/8.a381c0f5.png";